import React, { Component } from "react"
import PropTypes from "prop-types"
import { Radium } from "higher-order-components"
import { FullWidthImageSection, WysiwygContent } from "components"
import { HeadingBlock } from "containers"
import COLOR_PALETTE from "constants/color-palette"
import { injectGlobal } from "styled-components"
import globalStyles from "./article-styles.global.css"
import componentParser from "AtomicUtils/componentParser"
import { A } from 'AtomicComponents'

if (process.env.BABEL_ENV && process.env.BABEL_ENV === "dingo") {
  injectGlobal`
    ${globalStyles}
  `
} else {
  require("./article-styles.global.css")
}


const ZoomZoom = () => (
  <svg height="0.8em" viewBox="0 0 170 13" style={{width:"100px"}}>
    <title>Mazda Zoom-Zoom logo</title>
    <path
      fill="currentColor"
      d="M142.7 5.7c.7-.9 1.1-2.1 1.2-3.2 0-.7-.3-1.4-.9-1.8-.9-.5-1.8-.7-2.8-.6h-5.5c-.9 0-1.7.1-2.6.2-.7.1-1.3.3-1.9.7-.6.3-1.1.8-1.6 1.3-.6.7-1.1 1.4-1.6 2.1l-1.9 3.1c-.7.9-1 2.1-1.1 3.2 0 .7.3 1.4.9 1.8.9.5 1.8.7 2.8.6h5.5c.9 0 1.7-.1 2.5-.2.7-.1 1.3-.3 1.9-.7.6-.3 1.1-.8 1.6-1.3.6-.7 1.1-1.4 1.6-2.1l1.9-3.1zm-4.4 2.7c-.3.5-.6 1-1 1.5-.3.3-.6.6-1 .8-.4.2-.8.3-1.2.4-.5.1-1.1.1-1.6.1h-4.6c-.6 0-1.1-.1-1.6-.3-.4-.2-.6-.5-.6-.9.1-.8.4-1.6.9-2.3l2-3.1c.3-.5.6-1 1-1.4.6-.7 1.4-1.1 2.3-1.3.5-.1 1.1-.1 1.6-.1h4.5c.6 0 1.1.1 1.6.3.4.2.6.5.6.9-.1.8-.4 1.6-.9 2.3l-2 3.1zm-13.1-6c0-.7-.3-1.4-.9-1.8-.9-.5-1.8-.7-2.8-.6H116c-.9 0-1.7.1-2.6.2-.7.1-1.3.3-1.9.7-.6.4-1.1.8-1.5 1.4-.6.7-1.1 1.4-1.6 2.1l-1.9 3.1c-.7.9-1.1 2.1-1.2 3.2 0 .7.3 1.4.9 1.8.9.5 1.8.7 2.8.6h5.5c.9 0 1.7-.1 2.5-.2.7-.1 1.3-.3 1.9-.7.6-.3 1.1-.8 1.6-1.3.6-.7 1.1-1.4 1.6-2.1l1.9-3c.7-1 1.1-2.2 1.2-3.4zm-3.6 2.8l-2 3.1c-.3.5-.6 1-1 1.5-.3.3-.6.6-1 .8-.4.2-.8.3-1.2.4-.5.1-1.1.1-1.6.1h-4.6c-.6 0-1.1-.1-1.6-.3-.3-.2-.6-.5-.6-.9.1-.8.4-1.6.9-2.3l2-3.1c.3-.5.6-1 1-1.4.6-.7 1.4-1.1 2.3-1.3.5-.1 1.1-.1 1.6-.1h4.6c.6 0 1.1.1 1.6.3.4.2.6.5.6.9-.1 1-.4 1.7-1 2.3zM37.8 2.5c0-.7-.3-1.4-1-1.8C36 .2 35-.1 34.1 0h-5.5c-.9 0-1.7.1-2.6.2-.7.1-1.3.3-1.9.7-.6.3-1.1.8-1.5 1.3-.6.6-1.1 1.3-1.6 2.1l-1.9 3.1c-.7.9-1.1 2-1.1 3.2 0 .7.3 1.4.9 1.8.9.5 1.8.7 2.8.6h5.5c.9 0 1.7-.1 2.5-.2.7-.1 1.3-.3 1.9-.7.6-.3 1.1-.8 1.6-1.3.6-.7 1.1-1.4 1.5-2.1l1.9-3c.8-1 1.1-2.1 1.2-3.2zm-3.5 2.8l-2 3.1c-.3.5-.6 1-1 1.5-.3.3-.6.6-1 .8-.4.2-.8.3-1.2.4-.5.1-1.1.1-1.6.1h-4.7c-.6 0-1.1-.1-1.6-.3-.3-.2-.6-.5-.6-.9.1-.8.4-1.6.9-2.3l2-3.1c.3-.5.6-1 1-1.4.6-.7 1.4-1.1 2.3-1.3.5-.1 1.1-.1 1.6-.1H33c.6 0 1.1.1 1.6.3.4.1.6.5.6.9-.1.8-.4 1.6-.9 2.3zM21.1 1l.5-1H7.3l-1 1.8h10.1L.6 12 0 13h15l1-1.8H5.3L21.1 1zm148-.1c-.8-.5-1.8-.7-2.7-.7h-4c-.4 0-.9.1-1.3.2s-.8.2-1.1.4c-.4.2-.7.4-1 .7-.2-.4-.6-.8-1-1-.7-.3-1.5-.4-2.2-.3h-2.4c-.7 0-1.3 0-1.8.1-.5 0-.9.1-1.4.2l.2-.5h-2.2l-7.6 13h2.5l4-6.6c.6-.9 1.1-1.7 1.5-2.3.4-.5.8-1 1.3-1.4.4-.3.9-.5 1.4-.6.6-.1 1.2-.1 1.7-.1h1.7c.5 0 1 .1 1.5.3.3.2.5.6.5 1 0 .6-.3 1.2-.6 1.7l-4.8 8.1h2.5l3.9-6.6c.6-.9 1.1-1.7 1.5-2.3.4-.5.8-1 1.3-1.3.4-.3.9-.5 1.4-.6.6-.1 1.2-.1 1.8-.1h1.6c1.4 0 2.1.4 2.1 1.2 0 .6-.3 1.2-.6 1.6l-4.8 8h2.5l4.8-8c.4-.7.7-1.5.8-2.3-.1-.8-.4-1.5-1-1.8zm-60.6.1l.5-1H94.7l-1.1 1.8h10.1L87.9 12l-.6 1h15l1.1-1.8H92.7L108.5 1zM55.3 5.7c.7-.9 1.1-2.1 1.2-3.2 0-.7-.3-1.4-.9-1.8-.9-.5-1.8-.7-2.8-.6h-5.5c-.9 0-1.7.1-2.5.2-.7.1-1.3.3-1.9.7-.6.3-1.1.8-1.5 1.3-.6.7-1.1 1.4-1.6 2.1l-1.9 3.1c-.7.9-1.1 2.1-1.2 3.2 0 .7.3 1.4.9 1.8.9.5 1.8.7 2.8.6h5.5c.9 0 1.7-.1 2.5-.2.7-.1 1.3-.3 1.9-.7.6-.3 1.1-.8 1.5-1.3.6-.7 1.1-1.4 1.5-2.1l2-3.1zm-4.4 2.7c-.3.5-.6 1-1 1.5-.3.3-.6.6-1 .8-.4.2-.8.3-1.2.4-.5.1-1.1.1-1.6.1h-4.7c-.6 0-1.1-.1-1.6-.3-.3-.2-.6-.5-.6-.9.1-.8.4-1.6.9-2.3l2-3.1c.3-.5.6-1 1-1.4.6-.7 1.4-1.1 2.3-1.3.5-.1 1.1-.1 1.6-.1h4.6c.6 0 1.1.1 1.6.3.4.2.6.5.5.9-.1.8-.4 1.6-.9 2.3l-1.9 3.1zm40.7-2.9H84l-1.2 1.9h7.6l1.2-1.9zM81.7.8C80.9.3 80 .1 79 .2h-3.9c-.4 0-.9.1-1.3.2s-.8.2-1.1.4c-.4.2-.7.4-1 .7-.2-.4-.6-.8-1-1-.7-.3-1.5-.4-2.3-.3h-2.3c-.7 0-1.3 0-1.8.1-.5 0-.9.1-1.4.2l.3-.5H61l-7.6 13h2.5l4-6.6c.5-.9 1-1.7 1.5-2.3.4-.5.8-1 1.3-1.3.4-.3.9-.5 1.3-.6.5-.2 1.1-.2 1.7-.2h1.7c.5 0 1 .1 1.5.3.3.2.5.6.5 1 0 .6-.3 1.2-.6 1.7L64 13h2.5l3.9-6.6c.6-.9 1-1.7 1.5-2.3.4-.5.8-1 1.3-1.3.4-.3.9-.5 1.3-.6.6-.2 1.2-.2 1.8-.2h1.6c1.4 0 2.1.4 2.1 1.2 0 .6-.3 1.2-.6 1.7L74.6 13h2.5l4.8-8c.5-.7.7-1.5.8-2.4-.1-.7-.4-1.4-1-1.8z" />
  </svg>
)

const ArticleHeader = props => (
  <div
    style={{
      fontSize: "12px",
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      color: "#9e9e9e",
      padding: "1em 2em",
      backgroundColor: "white",
      borderBottom: "solid 1px #eaeaea",
      fontWeight: 600
    }}>
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        flexGrow: 1,
        justifyContent: "flex-start"
      }}>
      <ZoomZoom />
      <div
        style={{
          display: "inline-block",
          borderLeft: "solid 1px #cccccc",
          width: "2px",
          height: "1.2em",
          margin: "0.3em 1em"
        }} />
      <A
        withoutStyle
        style={{
          color: "#9e9e9e",
          textDecoration: "none",
          textTransform: "uppercase"
        }}
        href={props.backUrl}>
        &lt; Back to beyond the drive
      </A>
    </div>
    <div style={{ color: "black", textTransform: "uppercase" }}>posted on {props.publishDate}</div>
  </div>
)

ArticleHeader.propTypes = {
  publishDate: PropTypes.string,
  backUrl: PropTypes.string
}

class ArticlePageContainer extends Component {
  static propTypes = {
    publishDate: PropTypes.string,
    backUrl: PropTypes.string,
    backgroundColor: PropTypes.string,
    preHeading: PropTypes.string,
    heading: PropTypes.string,
    description: PropTypes.string,
    featureImage: PropTypes.string,
    featureImageCaption: PropTypes.string,
    content: PropTypes.string,
    styleName: PropTypes.oneOf(["news", "editorial"]),
    disableDropCap: PropTypes.bool,
    hero: PropTypes.array,
    components: PropTypes.array,
    children: PropTypes.node
  }

  static defaultProps = {
    disableDropCap: false
  }

  render() {
    const {
      preHeading,
      heading,
      description,
      content,
      featureImage,
      featureImageCaption,
      styleName,
      publishDate,
      backUrl,
      backgroundColor,
      children,
      components,
      hero,
      disableDropCap
    } = this.props

    const date = new Date(publishDate)
    const dateString = `${date.getDate()}/${1 + date.getMonth()}/${1900 + date.getYear()}`

    if (styleName === "news") {
      return (
        <div style={{ backgroundColor: backgroundColor }}>
          {/* Header */}
          <ArticleHeader publishDate={dateString} backUrl={backUrl} />
          {/* Hero components */}
          {componentParser(hero)}
          {featureImage && (
            <div style={{ maxWidth: "80em", margin: "auto" }}>
              <img
                src={featureImage}
                alt={heading}
                style={{
                  width: "100%",
                  padding: "3em 3em 0",
                  boxSizing: "border-box"
                }} />
              <p style={styles.caption}>{featureImageCaption}</p>
            </div>
          )}
          <div style={styles.articleColumn}>
            <HeadingBlock value={heading} />
            {description && (
              <WysiwygContent
                className="beyond-drive__article-description"
                style={{
                  color: COLOR_PALETTE.GRAY_DARKER,
                  paddingBottom: "1em",
                  margin: "1em 0px",
                  borderBottom: "1px solid #ccc"
                }}
                xmlString={description} />
            )}
            <WysiwygContent
              className={disableDropCap ? "" : "beyond-drive__article-body"}
              style={{ padding: "1em 0" }}
              xmlString={content} />
          </div>
          {components && componentParser(components)}
          {!components && children}
        </div>
      )
    }
    return (
      <div style={{ backgroundColor: backgroundColor }}>
        <ArticleHeader publishDate={dateString} />
        {componentParser(hero)}
        <FullWidthImageSection
          backgroundImage={featureImage}
          preHeading={preHeading}
          heading={heading}
          align="center"
          textAlign="center"
          blurb={description} />
        <div style={styles.articleColumn}>
          <WysiwygContent
            className="beyond-drive__article-body"
            style={{ padding: "1em 0" }}
            xmlString={content} />
        </div>
        {components && componentParser(components)}
        {!components && children}
      </div>
    )
  }
}

export default Radium(ArticlePageContainer)

const styles = {
  caption: {
    textAlign: "center",
    fontWeight: "300",
    color: "#9e9e9e",
    fontSize: "90%",
    fontStyle: "italic"
  },
  articleColumn: {
    maxWidth: "60em",
    margin: "auto",
    padding: "2em",
    overflow: "auto"
  }
}



// WEBPACK FOOTER //
// ./src/containers/article-page/index.jsx